import { useCallback } from 'react';

export const useColumnReordering = (effectiveColumnOrder, isColumnPinned, setColumnOrder) => {
  const handleDragStart = useCallback((e, columnId) => {
    e.dataTransfer.setData('text/plain', columnId);
    e.dataTransfer.effectAllowed = 'move';
    document.body.classList.add('column-dragging');
  }, []); // No dependencies needed as it only uses its own arguments and global document

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  }, []); // No dependencies needed

  const handleDrop = useCallback(
    (e, targetColumnId) => {
      e.preventDefault();
      document.body.classList.remove('column-dragging');

      const sourceColumnId = e.dataTransfer.getData('text/plain');

      if (
        sourceColumnId === targetColumnId ||
        isColumnPinned(sourceColumnId) ||
        isColumnPinned(targetColumnId)
      ) {
        return;
      }

      const currentOrder = [...effectiveColumnOrder];
      const sourceIndex = currentOrder.indexOf(sourceColumnId);
      const targetIndex = currentOrder.indexOf(targetColumnId);

      if (sourceIndex !== -1 && targetIndex !== -1) {
        const newOrder = [...currentOrder];
        newOrder.splice(sourceIndex, 1);
        newOrder.splice(targetIndex, 0, sourceColumnId);
        setColumnOrder(newOrder);
      }
    },
    [effectiveColumnOrder, isColumnPinned, setColumnOrder]
  );

  const handleDragEnd = useCallback(() => {
    document.body.classList.remove('column-dragging');
  }, []); // No dependencies needed

  return {
    handleDragStart,
    handleDragOver,
    handleDrop,
    handleDragEnd,
  };
};